{
  "close": "Bezárás",
  "notifications": "{count, plural, one {# értesítés} other {# értesítés}}."
}
